import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * The workspace time range: one setting in the top bar that every view reads
 * (threat queue, analytics, ATT&CK), so numbers on different pages describe
 * the same period. Remembered per browser.
 */
export const RANGES = [
  { days: 1, label: 'Last 24 hours', short: '24h' },
  { days: 7, label: 'Last 7 days', short: '7d' },
  { days: 30, label: 'Last 30 days', short: '30d' },
  { days: 90, label: 'Last 90 days', short: '90d' },
  { days: 365, label: 'Last 12 months', short: '12m' },
];
const KEY = 'is.range';
const DEFAULT_DAYS = 30;

const read = () => {
  try {
    const v = Number(localStorage.getItem(KEY));
    return RANGES.some((r) => r.days === v) ? v : DEFAULT_DAYS;
  } catch {
    return DEFAULT_DAYS;
  }
};

const TimeRangeContext = createContext({ days: DEFAULT_DAYS, range: RANGES[2], setDays: () => {} });

export function TimeRangeProvider({ children }) {
  const [days, setDaysState] = useState(read);
  const setDays = useCallback((d) => {
    setDaysState(d);
    try { localStorage.setItem(KEY, String(d)); } catch { /* private mode: keep it for this session only */ }
  }, []);
  const value = useMemo(() => ({ days, range: RANGES.find((r) => r.days === days) || RANGES[2], setDays }), [days, setDays]);
  return <TimeRangeContext.Provider value={value}>{children}</TimeRangeContext.Provider>;
}

export const useTimeRange = () => useContext(TimeRangeContext);
